import { render, staticRenderFns } from "./Credit-Note-Create.vue?vue&type=template&id=4e6007fc&"
import script from "./Credit-Note-Create.vue?vue&type=script&lang=js&"
export * from "./Credit-Note-Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports